import * as React from "react";
import { Control, Controller, FieldErrors, UseFormRegister } from "react-hook-form";
import { Form, Label } from "semantic-ui-react";

import { AddBillingTaskFormModel } from "../../../task/billingTask/model";
import { TaskType } from "../../../task/model";

interface AddBillingTaskFormProps {
    register: UseFormRegister<AddBillingTaskFormModel>;
    control: Control<AddBillingTaskFormModel, any>;
    errors: FieldErrors<AddBillingTaskFormModel>;
    subTasks: TaskType["subTasks"];
}

export const AddBillingTaskForm: React.FunctionComponent<AddBillingTaskFormProps> = ({ register, control, errors, subTasks }) => {
    return (
        <>
            <Form.Field>
                <Controller
                    name="taskCode"
                    control={control}
                    render={({ field: { onChange, value } }) =>
                        (<Form.Dropdown
                            selection
                            search
                            required
                            placeholder="Select Task *"
                            name="taskCode"
                            options={subTasks.map(type => ({ key: type, value: type, text: type }))}
                            onChange={(e, data) => onChange(data.value)}
                            value={value}
                        />)
                    }
                />
                {errors.taskCode?.message
                    && (<Label pointing="above" color="red">{errors.taskCode.message}</Label>)
                }
            </Form.Field>
            <Form.Field>
                <label>Amount *</label>
                <input {...register("amount")} placeholder="Enter a value between 5.00 and 5000.00" />
                {errors.amount?.message
                    && (<Label pointing="above" color="red">{errors.amount.message}</Label>)
                }
            </Form.Field>
            <Form.Field>
                <label>Notes</label>
                <textarea {...register("notes")} rows={3} />
            </Form.Field>
        </>
    );
};
